import { FoodsBadge } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type ScoresBodyHeaderProps = {
    scoresCount?: number | null;
};
export const ScoresBodyHeader = (props: ScoresBodyHeaderProps) => {
    const { scoresCount } = props;

    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection="row" gap={theme.spacing(1)}>
                <FoodsBadge
                    size={5}
                    icon={"scoresIndicators"}
                    boxProps={{
                        sx: {
                            padding: theme.spacing(1),
                            color: theme.palette.primary[500],
                            backgroundColor: theme.palette.primary[50],
                            borderRadius: "8px",
                        },
                    }}
                />
                <Typography variant="h3" alignSelf={"center"}>
                    {t("company.overview.scores_title", "My scores and indicators")}
                </Typography>
                {(scoresCount ?? 0) >= 4 && (
                    <>
                        <Typography variant="huge" alignSelf={"center"}>
                            {"-"}
                        </Typography>
                        <Typography variant="huge" alignSelf={"center"} sx={{ transform: "translateY(0.5px)" }}>
                            {`${scoresCount}`}
                        </Typography>
                    </>
                )}
            </Stack>
        </Stack>
    );
};
